import type { Priority } from "@/types";

export function buildBlockedNote(priority: Priority): string | null {
  if (priority.status !== "blocked") return null;
  const assignReasons =
    priority.assignments
      ?.map((a) => {
        if (!a.blockedReason?.trim()) return null;
        return `${a.assignedUser.fullName}: ${a.blockedReason.trim()}`;
      })
      .filter(Boolean) as string[] | undefined;
  if (priority.blocker && assignReasons?.length) {
    return `${priority.blocker.fullName} — ${assignReasons.join("; ")}`;
  }
  if (assignReasons?.length) return assignReasons.join("; ");
  const assignBlockers = priority.assignments?.filter((a) => a.blocker?.fullName);
  if (assignBlockers?.length) {
    return assignBlockers
      .map((a) => `${a.assignedUser.fullName} blocked by ${a.blocker!.fullName}`)
      .join("; ");
  }
  if (priority.blocker) return `Blocked — ${priority.blocker.fullName}`;
  return "This priority is blocked.";
}
